import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { CheckInDto } from '../../check-ins/dtos/check-in.dto';
import { CheckOutDto } from '../../check-outs/dtos/check-out.dto';

import { CreateVehicleMaintenanceDto } from './create-vehicle-maintenance.dto';

/**
 * Update vehicle maintenance DTO
 */
export class UpdateVehicleMaintenanceDto extends CreateVehicleMaintenanceDto {
	@TransformInt()
	id!: number;
	checkIns?: CheckInDto[];
	checkOuts?: CheckOutDto[];
}
